import React, { useState } from "react";
import { Modal, Form, Button } from "react-bootstrap";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import "./ChangePhoneNumber.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft } from "@fortawesome/free-solid-svg-icons";

const ChangePhoneNumber = ({ show, handleClose, openVerifyModal }) => {
  const [phone, setPhone] = useState("918329717621");

  const handleSaveSubmit = (e) => {
    e.preventDefault();

    console.log(phone);

    // Open Verify Modal
    openVerifyModal();
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      size="lg"
      dialogClassName="common-modal change-phone-modal"
    >
      <Modal.Header className="change-phone-header">
        <div className="d-flex align-items-center w-100">
          <Button
            variant="link"
            className="we-back-btn p-0 me-2"
            onClick={handleClose}
          >
            <FontAwesomeIcon icon={faAngleLeft} />
          </Button>

          <Modal.Title className="modal-title-text">
            Change Phone Number
          </Modal.Title>

          <button className="btn-close ms-auto" onClick={handleClose}></button>
        </div>
      </Modal.Header>

      <Modal.Body className="change-phone-body">
        <Form onSubmit={handleSaveSubmit}>
          <Form.Label className="phone-label">
            Change Phone Number
            <span className="text-danger">*</span>
          </Form.Label>

          <PhoneInput
            country={"in"}
            value={phone}
            onChange={(value) => setPhone(value)}
            inputClass="phone-input"
            buttonClass="phone-dropdown"
            containerClass="phone-container"
            dropdownClass="phone-country-list"
          />
        </Form>
      </Modal.Body>

      <Modal.Footer className="change-phone-footer">
        <Button className="save-btn" onClick={handleSaveSubmit}>
          Save & Verify
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ChangePhoneNumber;
